import api from './axios';

export const listar = () => api.get('/enderecos-entrega/');
